<video autoplay muted playsinline #videoEl [style.object-fit]="objectFit"></video>
